import WorkerApiService from "../workerApiServices"

class ComponenteDigitalService extends WorkerApiService {

    constructor() {
        super('/api/componente_digital')
    }

    buscaComponenteDigital(idComponenteDigital){
        let params = `?`
        params = `${params}&idComponenteDigital=${idComponenteDigital}`
        return this.get(`/buscaComponenteDigital${params}`)
    }

}

export default ComponenteDigitalService